import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-campaign-dialog',
  templateUrl: './update-campaign-dialog.component.html',
  styleUrl: './update-campaign-dialog.component.css'
})
export class UpdateCampaignDialogComponent {

  name: string = '';
  note: string = '';
  color: string = '#000000';

  tmpPriceCampaign: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string; name: string; note: string; color: string; priceCampaigns: any },
    private ref: MatDialogRef<UpdateCampaignDialogComponent>
  ) {

  }


  ngOnInit(): void {
    this.name = this.data.name;
    this.note = this.data.note;
    this.color = this.data.color;
    this.tmpPriceCampaign = this.data.priceCampaigns
  }

  removePrice(priceCampaignId: string) {
    this.tmpPriceCampaign = this.tmpPriceCampaign.filter((e: any) => e.id !== priceCampaignId);
  }

  addPrice() {
    this.tmpPriceCampaign.push({ id: `new_${+new Date()}`, name: '', campaign_group_id: this.data.id })
  }

  close() {
    this.ref.close({ confirm: false });
  }

  confirm() {
    const dataUpdate = {
      name: this.name,
      note: this.note,
      color: this.color,
      priceCampaign: this.tmpPriceCampaign
    }
    this.ref.close({ confirm: true, data: dataUpdate });
  }

}
